import { get } from 'lodash';
import { apiClientInstance } from './axiosClient';
import { metricsApi } from './metricsApi';

const extractErrorMessage = err =>
    err.response
        ? get(err, 'response.data.message', 'Unknown error')
        : err.message;

// eslint-disable-next-line import/prefer-default-export
export const getPromotionsBySweepId = async ({ sweepId }) => {
    try {
        const { data } = await apiClientInstance.get(
            `/client/sweepstake/${sweepId}/promotions`
        );

        return {
            data: data || null,
            errorMessage: null
        };
    } catch (err) {
        const statusCode = get(err, 'response.status', 500);
        await metricsApi.errorMetric(
            'getPromotionsBySweepId',
            statusCode,
            extractErrorMessage(err)
        );

        return {
            data: null,
            errorMessage: null // Don't show any error to the user, just no promos
        };
    }
};
